import { RestService } from "./RestService";

export class ScheduledPromotionService extends RestService {
    constructor() {
        super("/api/v1/scheduled_promotions");
    }
}
